import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RevealDirective } from '@ledgerly/common/browser';

@Component({
  selector: 'app-privacy-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RevealDirective, RouterLink],
  templateUrl: './privacy-section.component.html',
})
export class PrivacySectionComponent {
  /**
   * The app's own proof points, word for word. Short, concrete, and something
   * a reader can test in a minute. That beats a claim they have to believe.
   */
  protected readonly proofs = [
    $localize`:@@privacyProof1:No sign-up`,
    $localize`:@@privacyProof2:Works with airplane mode on`,
    $localize`:@@privacyProof3:Backups only if you ask`,
  ];

  /**
   * The exceptions, named.
   *
   * These are the three things the app itself sends. This site's own analytics
   * are deliberately not in the list: this section is about the app, and the
   * website is not part of the product. The website is covered on `/privacy`,
   * where it belongs.
   *
   * If any of these three stops being true, or a fourth appears, it goes here
   * and on `/privacy` the same day.
   */
  protected readonly network = [
    {
      title: $localize`:@@privacyNet1Title:Backup, once you turn it on`,
      detail: $localize`:@@privacyNet1Detail:Google Drive, iCloud or a file you choose. It copies everything, which is why it stays off until you say so.`,
    },
    {
      title: $localize`:@@privacyNet2Title:Your purchase`,
      detail: $localize`:@@privacyNet2Detail:Handled by RevenueCat through your App Store or Google Play account. It knows you paid. It does not know what you spent.`,
    },
    {
      title: $localize`:@@privacyNet3Title:Crash reports`,
      detail: $localize`:@@privacyNet3Detail:Sent to Sentry so a crash can be fixed instead of guessed at. They carry the fault, not your numbers.`,
    },
  ];
}
